import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "PlayerContainer" */ './container/PlayerContainer'));
